import { CandidateDocumentMetadataDto } from 'src/app/compliance/api/models/candidate-document-metadata-dto.model';
import { createAction, props } from '@ngrx/store';

export const getPriorContractMetadata = createAction(
    '[COMPLIANCE METADATA] Get Prior Contract Metadata Information',
    props<{ contractId: number; documentTypeId: number; candidateDocumentId: number }>()
);

export const getPriorContractMetadataSuccess = createAction(
    '[COMPLIANCE METADATA] Get Prior Contract Metadata Information Success',
    props<{ result: CandidateDocumentMetadataDto[] }>()
);

export const getPriorContractMetadataFailure = createAction(
    '[COMPLIANCE METADATA] Get Prior Contract Metadata Information Failure',
    props<{ error: unknown }>()
);
